// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6mrst","question":"styles_question__3gE_7","description":"styles_description__2BE45"};